import request from '@/util/request';

// 获取字典
export const getDictApi = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

// 获取项目列表
export const getProjectListApi = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取用户信息
export const getUserInfoApi = (params, options) =>
  request.get('/api/blade-user/info', Object.assign({}, options, { params }));

// 文件下载
export const downloadFile = (fileUrl, fileName) => {
  let url =
    '/api/v4ward/oss/customEndpoint/downloadFile?fileUrl=' + fileUrl + '&fileName=' + fileName;
  let a = document.createElement('a'); // 创建隐藏的可下载链接
  a.download = fileName;
  a.style.display = 'none';
  a.href = url;
  document.body.appendChild(a);
  a.click(); // 触发点击
  document.body.removeChild(a); // 然后移除
};

// 新建工单
export const createOrderApi = (params, options) =>
  request.post('/api/v4ward/order/execute/callcenter/create', params, options);

// 获取工单列表
export const getOrderListApi = (params, options) =>
  request.get('/api/v4ward/order/getOrderListPage', Object.assign({}, options, { params }));

// 获取部门树
export const getDeptTreeApi = (params, options) =>
  request.get('/api/base/deptproperty/tree', Object.assign({}, options, { params }));
